import React, {useState, useEffect} from 'react'
import { ButtonRed, ThemeSwitcher } from '../../components/common/Button'
import { AuthInput, Input } from '../../components/common/Input'
import LovrFire from '../../lovrfire'

import {useHistory} from "react-router-dom"

export default function NewPassword() {
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [buttonState, setButtonState] = useState("Reset Password");

    const history = useHistory();

    const validatePassword = (password) => {
        var reg = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
        if (reg.test(password) == false) {
            return false;
        }
        return true;
    }

    const handleResetPassword = async () => {
        setButtonState("Please wait...");
        if (password === confirmPassword) {
          if (validatePassword(password)) {
            alert("Password length must be 8 aleast 8 chars long");
            setButtonState("Reset Password");
            return;
          }
          try {
            const code = window.location.href
              .split("new-password/")[1]
            try {
              const resp = await LovrFire.auth().verifyPasswordResetCode(code);
              console.log(resp, "reset code");
              try {
                const respReset = await LovrFire.auth().confirmPasswordReset(
                  code,
                  password
                );
                console.log(respReset, "password changed");
                setButtonState("PASSWORD CHANGED");
              } catch (e) {
                setButtonState("Reset Password");
                alert("password reset failed");
              }
            } catch (e) {
              setButtonState("Reset Password");
              alert("Reset code expired/invalid");
            }
          } catch (e) {
            setButtonState("Reset Password");
            console.log(e);
          }
        } else {
          setButtonState("Reset Password");
          alert("Password does not match");
        }
      };

    const handleInit = async () => {
        const code = window.location.href
        .split("new-password/")[1]
      try {
        await LovrFire.auth().verifyPasswordResetCode(code);
      } catch (e) {
          console.log( "error here" ,e)
      }
    } 

      useEffect( () => {
       handleInit();
      }, []);

      const navigateToLogin = () => {
          history.push('/login')
      }

    return (
        <div className='password-auth-card-wrapper' >
            <ThemeSwitcher />
            <div className='lover-authCard-wrapper-header'>
                <img className='lover-logo lover-logo-size' src={require('../../assets/icons/logo.svg')} />
            </div>
            <p className='auth-header'>New Password</p>
            <p className='auth-header-sub-text'>The password must contain at least 8 characters, at least 1 capital letter and at least 1 digit.</p>
            <div style={{width: '400px', maxWidth: '98%'}}>
                <AuthInput handleInputChange={(e)=>setPassword(e.target.value)} type='password'  placeholder='Password' icon='lock.svg' />
                <AuthInput type='password' handleInputChange={(e)=>setConfirmPassword(e.target.value)} placeholder=' Repeat Password' icon='lock.svg' />
                <ButtonRed handleOnClick={handleResetPassword}  text={buttonState} />
    {buttonState == 'PASSWORD CHANGED' ? <ButtonRed handleOnClick={navigateToLogin} text="Login Now"/> : <div> </div>}
            </div>
        </div>
    )
}
